
import ChatsApp from "./component/index";
import PageHeader from "../Ui_Components/PageHeader";

const Chats = () => {
  return (
    <>  
    {/* Header */}
     <PageHeader title="Chat" />
      <ChatsApp />
    </>
  );
};

export default Chats;
